import React from 'react'

const VideoScreenIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M10.4677 3.92188H6.54257C5.84855 3.92188 5.18296 4.19757 4.69222 4.68831C4.20148 5.17906 3.92578 5.84464 3.92578 6.53866V10.4638M27.4768 10.4638V6.53866C27.4768 5.84464 27.2011 5.17906 26.7104 4.68831C26.2197 4.19757 25.5541 3.92188 24.8601 3.92188H20.9349M20.9349 27.4729H24.8601C25.5541 27.4729 26.2197 27.1972 26.7104 26.7065C27.2011 26.2157 27.4768 25.5502 27.4768 24.8561V20.931M3.92578 20.931V24.8561C3.92578 25.5502 4.20148 26.2157 4.69222 26.7065C5.18296 27.1972 5.84855 27.4729 6.54257 27.4729H10.4677" stroke="white" strokeWidth="2.94388" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default VideoScreenIcon